import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class NoMatch extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  render() {
    return <div>{'NoMatch'}</div>;
  }
}

function mapStateToProps(state) {
  return Object.assign({}, state);
}

export default withRouter(connect(mapStateToProps)(NoMatch));
